import { stringifyToBase64 } from '@/helpers/stringHelper.js'

import { ROUTER_NAMES, PAGES_FOR_ROUTING_PARAMS, REDIRECT_PARAMS_COMPANY_OBJECT_TYPES } from '@/config/router/routerNamesConfig'
import { ROUTER_QUERY_KEYS } from '@/config/router/routerMapConfig.js'




/* наработки для #2229 */

// eslint-disable-next-line no-unused-vars
const action_info = {
	work_order_id: 123, // required
	work_type: 'field', // optional (field || logistic || repair) обязательно указываем если entity = 'work_order_id'
	view: 'map', // optional (card || list || map = для треков и полевых нарядов открытая аналитика || monitoring = отдельная страница)
}

// app.on-track.ai/c/900/redirect?rp=eyJ3b3JrX29yZGVyX2lkIjoxMjMsInZpZXciOiJtYXAiLCJ3b3JrX3R5cGUiOiJmaWVsZCJ9

// eslint-disable-next-line no-unused-vars
const events = {
	event_id: 14986492,
	view: 'list',
}

// eslint-disable-next-line no-unused-vars
const work_order = {
	work_order_id: 123,
	work_type: 'field',
	view: 'list',
}



/**
 * @deprecated The method should not be used
 */
export function getUndefinedRouterLink(payload = {
	// machine_id: 345,
}) {
	if (Object.prototype.hasOwnProperty.call(payload, 'machine_id')) {
		return getMachineRouterLink(payload.machine_id)
	}
	if (Object.prototype.hasOwnProperty.call(payload, 'doneWorkId')) {
		return getFieldDoneWorkRouterLink(payload.machine_id)
	}
	return null
}

export function getObjectRedirectRouterLink(type, id, payload, query, params) {
	// console.log('getRedirectRouterLink', type, id, payload, query, params)
	switch (true) {
		case type === REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.FIELD:
			return getFieldRouterLink(id, payload, query, params)

		case type === REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.MACHINE:
			return getMachineRouterLink(id, payload, query, params)
		case type === REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.EVENT:
			return getEventsRouterLink(id, payload, query, params)
		case type === REDIRECT_PARAMS_COMPANY_OBJECT_TYPES.LOGISTIC_ROUTE:
			return getLogisticRouteConstructorRouterLink(id, payload, query, params)
	}
	return null
}

/**
 * Get link to field
 * @param {number} fieldId id of field
 * @param {object} [payload] payload of router-link
 * @param {string} [payload.page=field_card] - page variant
 * @param {string} [payload.purpose=showing] purpose of link (showing || editing)
 * @param {object} [additionalQuery] additional query to props of router-link
 * @returns {object} router-link props "to"
 */
export function getFieldRouterLink(fieldId, payload = {}) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.FIELD_CARD,
		purpose: 'showing',
	}, payload)
	const linkConfig = {}

	if (!fieldId) {
		return {
			name: ROUTER_NAMES.FIELDS.TABLE,
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.FIELD_CARD && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.FIELDS.CARD
			linkConfig.params = {
				cardId: fieldId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.FIELDS_TABLE && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.FIELDS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: fieldId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.FIELDS_TABLE && params.purpose === 'editing':
			linkConfig.name = ROUTER_NAMES.FIELDS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: fieldId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.FIELDS_MAP && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.FIELDS.MAP
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.MAP_GLOBAL_FILTERS]: stringifyToBase64({
					previewEntityTypeId: `field___${fieldId}`,
				}),
			}
			break;
		default:
			linkConfig.name = ROUTER_NAMES.FIELDS.CARD
			linkConfig.params = {
				cardId: fieldId,
			}
			break;
	}

	return linkConfig
}

/**
 * Get link to machine
 * @param {number} machineId id of machine
 * @param {object} [payload] payload of router-link
 * @param {string} [payload.page=machine_card] - page variant
 * @param {string} [payload.purpose=showing] purpose of link (showing || editing || analytics)
 * @param {object} [additionalQuery] additional query to props of router-link
 * @returns {object} router-link props "to"
 */
export function getMachineRouterLink(machineId, payload = {}, additionalQuery = {}) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.MACHINE_CARD,
		purpose: 'showing',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.MACHINES.CARD,
		params: {
			cardId: machineId,
		},
	}

	if (!machineId) {
		return {
			name: ROUTER_NAMES.MACHINES.TABLE,
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.MACHINES_TABLE && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.MACHINES.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: machineId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.MACHINES_TABLE && params.purpose === 'editing':
			linkConfig.name = ROUTER_NAMES.MACHINES.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: machineId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.MOVEMENTS_MAP && params.purpose === 'showing': {
			linkConfig.name = ROUTER_NAMES.MACHINES.MOVEMENTS_MAP
			const mapGlobalFilterParams = {
				trackPreviewEntityTypeId: `machine___${machineId}`,
			}
			if (Object.prototype.hasOwnProperty.call(additionalQuery, 'period')) {
				mapGlobalFilterParams.period = additionalQuery.period
			}
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.MAP_GLOBAL_FILTERS]: stringifyToBase64(mapGlobalFilterParams),
			}
			break;
		}
		case params.page === PAGES_FOR_ROUTING_PARAMS.MOVEMENTS_MAP && params.purpose === 'analytics': {
			linkConfig.name = ROUTER_NAMES.MACHINES.MOVEMENTS_MAP
			const mapGlobalFilterParams = {
				trackAnalyticsEntityId: machineId,
			}
			if (Object.prototype.hasOwnProperty.call(additionalQuery, 'period')) {
				mapGlobalFilterParams.period = additionalQuery.period
			}
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.MAP_GLOBAL_FILTERS]: stringifyToBase64(mapGlobalFilterParams),
			}
			break;
		}
		default:
			linkConfig.name = ROUTER_NAMES.MACHINES.CARD
			linkConfig.params = {
				cardId: machineId,
			}
			break;
	}

	return linkConfig
}

/**
 * Get link to regulation
 * @param {number} regulationId id of machine
 * @param {object} [payload] payload of router-link
 * @param {string} [payload.page=card] - page variant
 * @param {string} [payload.purpose=showing] purpose of link (showing || editing || analytics)
 * @param {object} [additionalQuery] additional query to props of router-link
 * @returns {object} router-link props "to"
 */
export function getRegulationsRouterLink(regulationId, payload = {}, additionalQuery, currentRoute) {
	// eslint-disable-next-line no-unused-vars
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.MACHINE_CARD,
		purpose: 'showing',
	}, payload)
	const queryConfig = {}
	const linkConfig = {
		name: ROUTER_NAMES.REGULATIONS.CARD,
		params: {
			cardId: regulationId,
		},
	}

	if (currentRoute?.fullPath) {
		queryConfig[ROUTER_QUERY_KEYS.BACK_PATH_PARAMS] = stringifyToBase64(currentRoute.fullPath)
	}

	if (Object.keys(queryConfig).length) {
		linkConfig.query = queryConfig
	}

	// if (!regulationId) {
	// 	return {
	// 		name: ROUTER_NAMES.MACHINES.TABLE,
	// 	}
	// }

	return linkConfig
}

/**
 *
 * @param {number} planWorkId
 * @param {object} payload
 * @param {string} [payload.page=active_plan_works_table] - page variant
 * @param {string} [payload.purpose=showing] purpose of link (showing || editing)
 * @param {object} additionalQuery
 * @param {number} additionalQuery.regulationId - id of regulation
 * @param {number} additionalQuery.stageId - id of regulation type
 * @returns
 */
export function getActivePlanWorkRouterLink(planWorkId, payload={}, additionalQuery = {}) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.ACTIVE_PLAN_WORKS_TABLE,
		purpose: 'showing',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.ACTIVE_PLAN_WORKS.TABLE,
		query: {
			[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: planWorkId,
		},
	}

	if (!planWorkId) {
		return {
			name: ROUTER_NAMES.ACTIVE_PLAN_WORKS.TABLE,
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.ACTIVE_PLAN_WORKS_TABLE && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.ACTIVE_PLAN_WORKS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: planWorkId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.ACTIVE_PLAN_WORKS_TABLE && params.purpose === 'editing':
			linkConfig.name = ROUTER_NAMES.ACTIVE_PLAN_WORKS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: stringifyToBase64({ planWorkId, ...additionalQuery }),
			}
			break;
	}

	return linkConfig
}

/**
 * Получить ссылку на полевую фактическую работу
 * @param {number} doneWorkId id of doneWork
 * @param {object} [payload] payload of router-link
 * @param {string} [payload.page=card] - page variant (card || list || map || monitoring)
 * @param {string} [payload.purpose=showing] purpose of link (showing || editing || showingEvents || analytics)
 * @param {object} [additionalQuery] additional query to props of router-link
 * @returns {object} router-link props "to"
 */
export function getFieldDoneWorkRouterLink(doneWorkId, payload = {}, additionalQuery = {}) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.DONE_WORKS_ALL_FIELD_WORKS_MAP,
		purpose: 'analytics',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.DONE_WORKS_ALL_FIELD_WORKS.MAP,
		query: {},
	}
	// console.log('getFieldDoneWorkRouterLink', doneWorkId, payload, params, additionalQuery)
	if(!doneWorkId) {
		return {
			name: ROUTER_NAMES.DONE_WORKS_ALL_FIELD_WORKS.TABLE,
			query: Object.keys(additionalQuery)?.length ? {
				[ROUTER_QUERY_KEYS.TABLE_GLOBAL_FILTERS]: stringifyToBase64(additionalQuery),
			} : {},
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.DONE_WORKS_ALL_FIELD_WORKS_MAP && params.purpose === 'analytics':
			linkConfig.name = ROUTER_NAMES.DONE_WORKS_ALL_FIELD_WORKS.MAP
			linkConfig.query[ROUTER_QUERY_KEYS.MAP_GLOBAL_FILTERS] = stringifyToBase64({
				...additionalQuery,
				factAnalyticsEntityId: doneWorkId,
			})
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.DONE_WORKS_ALL_FIELD_WORKS_TABLE && params.purpose === 'showing':
			// linkConfig.name = ROUTER_NAMES.FIELD_DONE_WORKS_IN_PROGRESS.TABLE
			linkConfig.name = ROUTER_NAMES.DONE_WORKS_ALL_FIELD_WORKS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: doneWorkId,
			}
			break;
	}

	return linkConfig
}

/**
 * @deprecated The method should not be used
 * @param {number} doneWorkId
 * @param {object} payload payload of router-link
 * @returns {object} router-link props "to"
 */
export function getDynamicsDoneWorkRouterLink(doneWorkId/* , payload = {} */) {
	// const params = Object.assign({
	// 	view: 'list',
	// 	purpose: 'showing',
	// }, payload)
	// console.log(payload)

	const linkConfig = {
		name: ROUTER_NAMES.DYNAMICS_DONE_WORKS.LIST,
		query: {
			[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: doneWorkId,
		},
	}
	return linkConfig
}
 /**
 * @deprecated The method should not be used
 * @param {number} generatorId id of generator
 * @param {object} payload  payload of router-link
 * @param {string} [payload.view=card] - view variant (card || list)
 * @param {string} [payload.purpose=showing] purpose of link (showing || editing || showFieldsExecutors, showParams, showResults)
 * @param {object} [additionalQuery] additional query to props of router-link
 * @returns {object} router-link props "to"
 */
export function  getOrdersGeneratorsFieldsWorksRouterLink (generatorId, payload = {} /* , additionalQuery = {} */) {

	const params = Object.assign({
		view: 'card',
		purpose: 'showing',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR,
		params: {
			generatorId: generatorId,
		},
	}

	switch (true) {
		case params.view === 'list' && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR_LIST
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: generatorId,
			}
			break;
		case params.view === 'list' && params.purpose === 'editing':
			linkConfig.name = ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR_LIST
			linkConfig.params = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: generatorId,
			}
			break;
			case params.view === 'card' && params.purpose === 'showFieldsExecutors':
				linkConfig.name = ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR_TABS.FIELDS_AND_EXECUTORS
				linkConfig.params = {
					generatorId: generatorId,
				}
			break;
			case params.view === 'card' && params.purpose === 'showParams':
				linkConfig.name = ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR_TABS.PARAMS
				linkConfig.params = {
					generatorId: generatorId,
				}
			break;
			case params.view === 'card' && params.purpose === 'showResults':
			linkConfig.name = ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR_TABS.RESULTS
			linkConfig.params = {
				generatorId: generatorId,
			}
			break;
		default:
			linkConfig.name = ROUTER_NAMES.FIELD_WORK_ORDERS.GENERATOR
			linkConfig.params = {
				generatorId: generatorId,
			}
			break;
	}

	return linkConfig
}
// перехід на таблицю подій з вказаними глобальними фільтрами
/**
 

 * @param {number} eventId id of event
 * @param {object} payload  payload of router-link
 * @param {string} [payload.view=list] - view variant (list)
 * @param {string} [payload.purpose=showing] purpose of link (showing || editingComment)
 * @param {object} [additionalQuery] additional query to props of router-link
 * @returns {object} router-link props "to"
 */
export function getEventsRouterLink(eventId, payload = {}, additionalQuery = {}) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.EVENTS_TABLE,
		purpose: 'showing',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.EVENTS.TABLE,
		query: {},
	}

	if (!eventId) {
		return {
			name: ROUTER_NAMES.EVENTS.TABLE,
			query: Object.keys(additionalQuery)?.length ? {
				[ROUTER_QUERY_KEYS.TABLE_GLOBAL_FILTERS]: stringifyToBase64(additionalQuery),
			} : {},
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.EVENTS_TABLE && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.EVENTS.TABLE
			linkConfig.query = Object.keys(additionalQuery)?.length ? {
				[ROUTER_QUERY_KEYS.TABLE_GLOBAL_FILTERS]: stringifyToBase64(additionalQuery),
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: eventId,
			} : {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: eventId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.EVENTS_TABLE && params.purpose === 'editingComment':
			linkConfig.name = ROUTER_NAMES.EVENTS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: eventId,
			}
			break;
	}

	return linkConfig
}

// перехід на конструктор маршрутаи
/**

 * @param {number} routeId id of logistic route
 * @param {object} payload  payload of router-link
 * @param {string} [payload.view=list] - view variant (list)
 * @param {string} [payload.purpose=showing] purpose of link (showing)
 * @param {object} [additionalQuery] additional query to props of router-link
 * @returns {object} router-link props "to"
 */
export function getLogisticRouteConstructorRouterLink(routeId, payload = {}) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.LOGISTIC_ROUTES_CONSTRUCTOR,
		purpose: 'showing',
	}, payload)

	const linkConfig = {
		name: ROUTER_NAMES.LOGISTIC_ROUTES.CONSTRUCTOR,
		params: {},
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.LOGISTIC_ROUTES_CONSTRUCTOR && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.LOGISTIC_ROUTES.CONSTRUCTOR
			linkConfig.params = {
				id: routeId,
			}
			break;
	}

	return linkConfig
}
export function getCargoRouterLink(cargoId, payload = {}/* , additionalQuery = {} */) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.CARGO_TRANSPORTED_TABLE,
		purpose: 'showing',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.LOGISTICS.CARGO_TRANSPORTED.TABLE,
	}

	if (!cargoId) {
		return {
			name: ROUTER_NAMES.LOGISTICS.CARGO_TRANSPORTED.TABLE,
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.CARGO_TRANSPORTED_TABLE && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.LOGISTICS.CARGO_TRANSPORTED.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: cargoId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.CARGO_TRANSPORTED_TABLE && params.purpose === 'editing':
			linkConfig.name = ROUTER_NAMES.LOGISTICS.CARGO_TRANSPORTED.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: cargoId,
			}
			break;
	}

	return linkConfig
}

export function getLandsRouterLink(landId, payload = {}/* , additionalQuery = {} */) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.LANDS_TABLE,
		purpose: 'showing',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.LAND_BANK.LANDS.TABLE,
	}

	if (!landId) {
		return {
			name: ROUTER_NAMES.LAND_BANK.LANDS.TABLE,
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.LANDS_TABLE && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.LAND_BANK.LANDS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: landId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.LANDS_TABLE && params.purpose === 'editing':
			linkConfig.name = ROUTER_NAMES.LAND_BANK.LANDS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: landId,
			}
			break;
	}

	return linkConfig
}
export function getLandDocumentRouterLink(landDocumentId, payload = {}/* , additionalQuery = {} */) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.LAND_DOCUMENTS_TABLE,
		purpose: 'showing',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.LAND_BANK.LAND_DOCUMENTS.TABLE,
	}

	if (!landDocumentId) {
		return {
			name: ROUTER_NAMES.LAND_BANK.LAND_DOCUMENTS.TABLE,
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.LAND_DOCUMENTS_TABLE && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.LAND_BANK.LAND_DOCUMENTS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: landDocumentId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.LAND_DOCUMENTS_TABLE && params.purpose === 'editing':
			linkConfig.name = ROUTER_NAMES.LAND_BANK.LAND_DOCUMENTS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: landDocumentId,
			}
			break;
	}

	return linkConfig
}

// перехід на таблицю логістичних нарядів
/**

 * @param {number} routeId id of logistic order
 * @param {object} payload  payload of router-link
 * @param {string} [payload.view=list] - view variant (list || map)
 * @param {string} [payload.purpose=showing] purpose of link (showing, editing, analytics)
 *  * @param {object} [additionalQuery] additional query to props of router-link
 * @returns {object} router-link props "to"
 */

export function getLogisticWorkOrdersLink(logisticOrderId, payload = {}, additionalQuery = {}) {
	const params = Object.assign({
		page: PAGES_FOR_ROUTING_PARAMS.WAYBILLS_MAP,
		purpose: 'analytics',
	}, payload)
	const linkConfig = {
		name: ROUTER_NAMES.LOGISTICS.WAYBILLS.MAP,
		query: {},
	}

	if (!logisticOrderId) {
		return {
			name: ROUTER_NAMES.LOGISTICS.WAYBILLS.TABLE,
			query: Object.keys(additionalQuery)?.length ? {
				[ROUTER_QUERY_KEYS.TABLE_GLOBAL_FILTERS]: stringifyToBase64(additionalQuery),
			} : {},
		}
	}

	switch (true) {
		case params.page === PAGES_FOR_ROUTING_PARAMS.WAYBILLS_MAP && params.purpose === 'analytics':
			linkConfig.name = ROUTER_NAMES.LOGISTICS.WAYBILLS.MAP
			linkConfig.query[ROUTER_QUERY_KEYS.MAP_GLOBAL_FILTERS] = stringifyToBase64({
				...additionalQuery,
				factAnalyticsEntityId: logisticOrderId,
			})
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.WAYBILLS_TABLE && params.purpose === 'showing':
			linkConfig.name = ROUTER_NAMES.LOGISTICS.WAYBILLS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_PREVIEW]: logisticOrderId,
			}
			break;
		case params.page === PAGES_FOR_ROUTING_PARAMS.WAYBILLS_TABLE && params.purpose === 'editing':
			linkConfig.name = ROUTER_NAMES.LOGISTICS.WAYBILLS.TABLE
			linkConfig.query = {
				[ROUTER_QUERY_KEYS.TABLE_OPENED_EDITING_FORM]: logisticOrderId,
			}
			break;
	}

	return linkConfig
}

